import { createRoot, hydrateRoot } from "react-dom/client";
import BrowserApp from "./BrowserApp";
import "./styles/index.css";

const root = document.getElementById("root");
const app = <BrowserApp />;

// Prerendered pages hydrate; the bare dev server page renders from scratch.
if (root.hasChildNodes()) hydrateRoot(root, app);
else createRoot(root).render(app);
